<article tabindex="0" (keydown)="onKeyPress($event)">
  <br>
    <section class="form">
      <div class="row">
        @if (!data.gain) {
          <button mat-flat-button class="home" data-testid="wheelBtnHome" (click)="btnHome()"
            >
            {{ 'components.wheelSelectorSetValueDialog.home' | transloco }}
          </button>
        }
        <div class="valeur">
          <span data-testid="value">&nbsp;{{ value }}&nbsp;</span>
        </div>
        @if (!data.gain) {
          <button mat-flat-button class="away" data-testid="wheelBtnAway" (click)="btnAway()"
            >
            {{ 'components.wheelSelectorSetValueDialog.away' | transloco }}
          </button>
        }
      </div>

      <div class="boutons">
        <div class="row">
          <button mat-flat-button class="nombre" data-testid="wheelBtn1" (click)="btn('1')">1</button>
          <button mat-flat-button class="nombre" data-testid="wheelBtn2" (click)="btn('2')">2</button>
          <button mat-flat-button class="nombre" data-testid="wheelBtn3" (click)="btn('3')">3</button>
        </div>
        <div class="row">
          <button mat-flat-button class="nombre" data-testid="wheelBtn4" (click)="btn('4')">4</button>
          <button mat-flat-button class="nombre" data-testid="wheelBtn5" (click)="btn('5')">5</button>
          <button mat-flat-button class="nombre" data-testid="wheelBtn6" (click)="btn('6')">6</button>
        </div>
        <div class="row">
          <button mat-flat-button class="nombre" data-testid="wheelBtn7" (click)="btn('7')">7</button>
          <button mat-flat-button class="nombre" data-testid="wheelBtn8" (click)="btn('8')">8</button>
          <button mat-flat-button class="nombre" data-testid="wheelBtn9" (click)="btn('9')">9</button>
        </div>
        <div class="row">
          <button mat-flat-button class="nombre" data-testid="wheelBtnPlusMoins" (click)="btnPlusMoins()" [class.hide]="!data.displayPlusMinusButton">-/+</button>
          <button mat-flat-button class="nombre" data-testid="wheelBtn0" (click)="btn('0')">0</button>
          <button mat-flat-button class="nombre" data-testid="wheelBtnEffacer" (click)="btnEffacer()"><mat-icon>backspace</mat-icon></button>
        </div>
      </div>
    </section>

    <div mat-dialog-actions class="toolbar-buttons">
      <button mat-flat-button data-testid="wheelCancel" (click)="cancel()"
        class="secondary-action-btn">
        {{ 'components.wheelSelectorSetValueDialog.cancel' | transloco }}
      </button>
      <button mat-flat-button color="primary" data-testid="wheelOk" (click)="ok()" class="primary-action-btn">
        {{ 'components.wheelSelectorSetValueDialog.ok' | transloco }}
      </button>
    </div>
  </article>
